import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useOpportunityJourney = (oppID, oppType) =>{
    const [opportunityData, setOpportunityData] = useState([]);
    useEffect(() => {
        if(!oppID || !oppType || oppID === 'No opportunity ID' || oppType === 'No opportunity type found'){
            return;
        }
        const fetchData = async () => {
            try{
                const queryParams = new URLSearchParams({
                    opp_id: oppID,
                })
                queryParams.append('opp_type', oppType)
                const response = await fetch(
                    `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_OPPORTUNITIES.JOURNEY}?${queryParams.toString()}`
                );
                const result = await response.json();
                console.log(result)
                // Assign data to state
                if(response.ok){
                    setOpportunityData(result.data)
                }else{
                    console.error("Failed to fetch opportunity :", result.error);
                }
            } catch (error){
                console.error("API Ping Error:", error);
            }
        };
        fetchData();
    }, [oppID, oppType]);
    
    return {opportunityData};
};